import locationsData from "./locations.json";

document.addEventListener("DOMContentLoaded", (event) => {
	const locations = locationsData.locations;
	const hasCoordinates = document.querySelectorAll(".coordinates");

	if (hasCoordinates && hasCoordinates.length > 0) {
		hasCoordinates.forEach(async (cell) => {
			await initCoordinates(cell);
		});
		const sectionsWithCordinates = document.querySelectorAll(".et_pb_section:has(.coordinates)");

		initCoordinatesCounter(sectionsWithCordinates);
	}

	async function initCoordinates(cell) {
		cell.setAttribute("data-width", 0);
		cell.setAttribute("data-max", 100);
		const codeContainer = cell.closest(".et_pb_code");
		const container = cell.parentElement;
		const location = cell.querySelector("& > span:first-child");
		const values = cell.querySelector("& > *:last-child");
		if (!values) return;
		const lat = values.querySelector(".lat");
		const lng = values.querySelector(".lng");

		const randomIndex = Math.floor(Math.random() * locations.length);

		//Set location name
		location.innerText = locations[randomIndex].cityName;
		lat.setAttribute("data-symbol", "° N");
		lat.setAttribute("data-lat", +locations[randomIndex].lat);
		// lat.innerText = locations[randomIndex].lat;
		lng.setAttribute("data-symbol", "° W");
		lng.setAttribute("data-lng", +locations[randomIndex].lng);
		// lng.innerText = locations[randomIndex].lng;
	}

	function initCoordinatesCounter(sections) {
		let options = {
			threshold: 0.5,
		};

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					const coordinatesAll = entry.target.querySelectorAll(".coordinates");
					coordinatesAll.forEach((coordinates) => {
						const lat = coordinates.querySelector(".lat");
						const lng = coordinates.querySelector(".lng");

						const updateCoordinates = () => {
							const interval = 100;

							const latCounter = parseFloat(lat.innerText) || 0;
							const latValue = parseFloat(lat.dataset.lat);
							const lngCounter = parseFloat(lng.innerText) || 0;
							const lngValue = parseFloat(lng.dataset.lng);
							const latIncrement = +(latValue / interval).toFixed(4);
							const lngIncrement = +(lngValue / interval).toFixed(4);

							if (latCounter < latValue) {
								lat.innerText = `${(latCounter + latIncrement).toFixed(4)} ${lat.getAttribute("data-symbol")}`;
							} else {
								lat.innerText = `${latCounter} ${lat.getAttribute("data-symbol")}`;
							}

							if (lngCounter < lngValue) {
								lng.innerText = `${(lngCounter + lngIncrement).toFixed(4)} ${lng.getAttribute("data-symbol")}`;
							} else {
								lng.innerText = `${lngCounter} ${lng.getAttribute("data-symbol")}`;
							}

							if (latCounter < latValue && lngCounter < lngValue) {
								setTimeout(updateCoordinates, 1);
							} else {
								observer.unobserve(entry.target);
							}
						};
						updateCoordinates();

						let cellWidth = +coordinates.dataset.width;
						const cellToGrow = coordinates.querySelector(".values ");
						const cellGrowthInterval = setInterval(callGrowthCallback, 100);

						function callGrowthCallback() {
							const interval = 10;

							if (cellWidth >= 100) {
								clearInterval(cellGrowthInterval);
								cellToGrow.style.overflow = "unset";
							} else {
								cellWidth += interval;
								cellToGrow.style.width = `${cellWidth}%`;
							}
						}
					});
				}
			});
		}, options);
		sections.forEach((section) => observer.observe(section));
	}
});
